import styled from 'styled-components'

export const ModalContainer = styled.div`
  width: 100%;
  margin-top: 24px;
  border-top: 1px solid ${p => p.theme.palette.colors.lightshadow};
  padding-top: 24px;
  border-radius: 14px;
`

export const PreviewHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
  gap: 8px;
  padding: 10px;
  border-radius: 10px;
  background: ${p => p.theme.palette.colors.surfaceElevated};
  color: ${p => p.theme.palette.colors.text};

  a, .MuiIconButton-root { color: inherit; flex-shrink: 0; }
`

export const PreviewMeta = styled.div`
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 10px;
  color: ${p => p.theme.palette.colors.text};
  font-family: Lato;
  font-size: 15px;
  font-style: normal;
  font-weight: 700;
  line-height: 1;
  letter-spacing: 0.1px;

  span {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: min(560px, 72vw);
  }
`

export const PreviewTag = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 6px 10px;
  border-radius: 999px;
  font-size: 11px;
  text-transform: uppercase;
  font-weight: 800;
  letter-spacing: 0.6px;
  color: ${p => p.theme.palette.white.main};
  background: linear-gradient(135deg, ${p => p.theme.palette.primary.main} 0%, ${p => p.theme.palette.blue.main} 100%);
`

export const PreviewBody = styled.div`
  overflow: auto;
  border-radius: 14px;
  border: 1px solid ${p => p.theme.palette.colors.lightshadow};
  box-shadow: 0 18px 40px rgba(0, 43, 69, 0.14);
  background: ${p => p.theme.palette.colors.backgroundgrey};
  padding: 10px;
  max-height: 76vh;

  .react-pdf__Document {
    display: flex;
    flex-direction: column;
    gap: 10px;
    align-items: center;
  }

  .react-pdf__Page {
    width: 100%;
    max-width: 950px;
    border-radius: 8px;
    overflow: hidden;
    background: ${p => p.theme.palette.white.main};
  }

  .react-pdf__Page__canvas {
    width: 100% !important;
    height: auto !important;
    display: block;
  }
`

export const PreviewFrame = styled.iframe`
  width: 100%;
  display: block;
  min-height: 70vh;
  border: 0;
  background: ${p => p.theme.palette.colors.backgroundgrey};

  @media (max-width: 768px) {
    min-height: 58vh;
  }
`

export const EmptyState = styled.div`
  width: 100%;
  border: 1px solid ${p => p.theme.palette.colors.lightshadow};
  border-radius: 12px;
  background: ${p => p.theme.palette.colors.backgroundgrey};
  padding: 18px 20px;
`

export const EmptyTitle = styled.div`
  font-size: 14px;
  color: ${p => p.theme.palette.primary.main};
  font-weight: 700;
  margin-bottom: 4px;
`

export const EmptyDescription = styled.div`
  font-size: 13px;
  color: ${p => p.theme.palette.colors.grey};
  font-weight: 500;
`

export const PreviewPage = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`

export const PreviewLoader = styled.div`
  width: 100%;
  min-height: 220px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: ${p => p.theme.palette.primary.main};
  font-size: 14px;
  font-weight: 700;

  &::before {
    content: '';
    width: 18px;
    height: 18px;
    border-radius: 50%;
    border: 2px solid ${p => p.theme.palette.primary.main};
    border-top-color: transparent;
    animation: pdfPreviewSpin 0.8s linear infinite;
  }

  .dots {
    display: inline-block;
    width: 1.5em;
    overflow: hidden;
  }

  .dots::after {
    content: '...';
    display: inline-block;
    animation: pdfPreviewDots 1s steps(4, end) infinite;
  }

  @keyframes pdfPreviewSpin {
    to {
      transform: rotate(360deg);
    }
  }

  @keyframes pdfPreviewDots {
    from {
      width: 0;
    }
    to {
      width: 1.5em;
    }
  }
`

export const PreviewLimitText = styled.div`
  margin-top: 10px;
  font-size: 12px;
  color: ${p => p.theme.palette.colors.grey};
  text-align: center;
  font-weight: 600;
`

export const ModalContent = styled.div.attrs({
})`
    gap: 16px;
    width: 100%;
    overflow-y: auto; 
    max-height: 90vh;
    box-sizing: border-box;
    animation: slideDown 0.3s ease-out;
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 1080px;
    border-radius: 8px;
    @keyframes slideDown {
        from {
            opacity: 0;
            transform: translateY(-100%);
        }
        to {
            opacity: 1;
            transform: translateY(0);
        }
    }

    @keyframes slideUp {
        from {
            opacity: 1;
            transform: translateY(0);
        }
        to {
            opacity: 0;
            transform: translateY(-100%);
        }
    }

    @media (max-width: 1000px) {
        padding: 20px;
        max-width: 100%;
        min-width: 100%;
    }

    @media (max-width: 480px) {
        padding: 15px;
        gap: 15px;
    }
`;

export const PreviewImage = styled.img`
  display: block;
  width: 100%;
  height: auto;
  max-height: 68vh;
  object-fit: contain;
`

export const PreviewVideo = styled.video`
  display: block;
  width: 100%;
  max-height: 68vh;
`
